import React from 'react';
import { useFlavour } from '../context/FlavourContext';

// Circular fruit flavour selectors row.
export default function FlavourSelector({ source = 'selector', size = 'md', className = '' }) {
  const { flavourId, setFlavour, order, all } = useFlavour();
  const dim = size === 'sm' ? 'w-14 h-14' : 'w-20 h-20 md:w-24 md:h-24';

  return (
    <div className={`flex items-start justify-center gap-4 md:gap-8 flex-wrap ${className}`}>
      {order.map((id) => {
        const f = all[id];
        const active = id === flavourId;
        return (
          <button
            key={id}
            onClick={() => setFlavour(id, source)}
            className="group flex flex-col items-center gap-2 focus:outline-none"
            aria-label={f.name}
          >
            <span className="relative block" style={{ transition: 'transform 180ms cubic-bezier(0.22,1,0.36,1)' }}>
              <span
                className="absolute inset-0 rounded-full blur-lg transition-opacity duration-300"
                style={{ background: f.primary, opacity: active ? 0.7 : 0.18 }}
              />
              <span
                className={`relative flex items-center justify-center ${dim} rounded-full overflow-hidden border-2 transition-transform duration-200 group-hover:scale-[1.08] ${active ? 'scale-105' : ''}`}
                style={{ borderColor: active ? f.primary : 'rgba(255,255,255,0.15)' }}
              >
                <img src={f.fruit} alt={f.name} loading="lazy" className="w-full h-full object-cover" />
              </span>
            </span>
            <span
              className="font-cond tracking-wide text-xs md:text-sm transition-colors"
              style={{ color: active ? f.primary : 'rgba(255,255,255,0.6)' }}
            >
              {f.name}
            </span>
            <span className="h-[2px] transition-all duration-300" style={{ width: active ? 28 : 0, background: f.primary }} />
          </button>
        );
      })}
    </div>
  );
}
